import React, { useState,useEffect,useRef } from "react";
import './classes/EditMentor.css';
import Editor from 'react-simple-wysiwyg';
import { configData } from "../config";
import { Link, useNavigate,useLocation  } from 'react-router-dom';

const EditMentor =({uid,userLoggedInRoles,userMentorAssets}) =>{

    const initialForm = {
        field_mentor_sort_order: '',
        field_mentor_title: '',
        field_mentor_biography: '',
        edit_mentor_photo_upload:'',
        field_mentor_photo:'',
        field_delete_photo:0,
        uid:uid
    }
    const [formData, setFormData] = useState(initialForm);
    
    
    const [selectedImage, setSelectedImage] = useState(null);
    const [savedImageInfo, setSavedImageInfo] = useState({ size: null});
    const [useEditor, setUseEditor] = useState(true);
    const [imageUploadError, setImageUploadError] = useState('');
    const app_url = configData.APP_URL;
    const[success,setSuccess] = useState({});
    const navigate = useNavigate();
    useEffect(() => {
    
       {userMentorAssets.length > 0 && (
            <>
            {userMentorAssets.map((item, index) => (
               setFormData(prevState => ({
            ...prevState,
            [item['key']]: item['value'] 
          }))
            )
            )}
            </>
          )}
   
     },[]);
    const handleChange = (e) => {
        const { name, value } = e.target;
            setFormData(prevState => ({
                ...prevState,
                [name]: value,
            }));
    };

// Check for empty/meaningless editor content
const isEditorEmpty = (html) => {
  const cleaned = (html || '').trim();
  return (
    cleaned === "" ||
    cleaned === "<p><br></p>" ||
    cleaned === "<p></p>" ||
    cleaned === "<br>" ||
    cleaned === "<p><br></p><p><br></p>"
  );
};

const looksLikeHtml = (text) => /<\/?[a-z][\s\S]*>/i.test((text || '').trim());

const wrapInParagraphs = (text) => {
  const t = (text || '').trim();
  if (!t) return "";
  return `<p>${t.replace(/\n+/g, "</p><p>")}</p>`;
};

// normalize what the rich editor should store (always HTML or "")
const normalizeRichHtml = (html) => {
  if (isEditorEmpty(html)) return "";

  const trimmed = (html || "").trim();

  // If it already has <p> tags but also has stray text outside tags
  // → wrap those stray parts in <p>
  if (looksLikeHtml(trimmed)) {
    // Replace any text nodes outside tags with wrapped paragraphs
    const div = document.createElement("div");
    div.innerHTML = trimmed;

    // wrap stray text nodes
    const wrapped = Array.from(div.childNodes).map((node) => {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== "") {
        return `<p>${node.textContent.trim()}</p>`;
      }
      return node.outerHTML || node.textContent;
    });

    return wrapped.join("").trim();
  }

  // Plain text → wrap as <p>
  return wrapInParagraphs(trimmed);
};


// onEditorChange: keep rich-mode representation normalized (HTML)
const onEditorChange = (e) => {
  const val = e.target.value;
  setFormData(prev => ({
    ...prev,
    field_mentor_biography: normalizeRichHtml(val),
  }));
};

// improved toggle that is symmetric & predictable
const toggleMentorBioEditor = () => {
  const switchingToRich = !useEditor;

  setFormData((prev) => {
    const value = prev.field_mentor_biography || "";

    if (switchingToRich) {
      // plain -> rich: ensure HTML (wrap plain text if necessary)
      return {
        ...prev,
        field_mentor_biography: normalizeRichHtml(value),
      };
    } else {
      // rich -> plain: show HTML markup in the textarea.
      // If value is plain text (no tags) we wrap it so textarea shows <p>..</p>.
      if (isEditorEmpty(value)) {
        return { ...prev, field_mentor_biography: "" };
      }
      return {
        ...prev,
        field_mentor_biography: looksLikeHtml(value) ? value : wrapInParagraphs(value),
      };
    }
  });

  setUseEditor(switchingToRich);
};




const handleFileChange = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
  const maxSize = 128 * 1024 * 1024; // 128 MB
  const errors = [];

  // Check file type
  if (!validTypes.includes(file.type)) {
    errors.push('Only files with the following extensions are allowed: <em>png, gif, jpg, jpeg</em>.');
  }

  // Check file size
  if (file.size > maxSize) {
    errors.push('File must be less than 128 MB.');
  }

  const img = new Image();
  const objectUrl = URL.createObjectURL(file);

  img.onload = () => {
    const { width, height } = img;

    if (width < 100 || height < 100 || width > 1000 || height > 1000) {
      errors.push('Image size must be a minimum of 100×100 px and a maximum of 1000×1000 px.');
    }

    URL.revokeObjectURL(objectUrl);

    if (errors.length > 0) {
      const errorHTML = `The selected file <em>${file.name}</em> cannot be uploaded.<br>${errors.join('<br>')}`;
      setImageUploadError(errorHTML);
      e.target.value = '';
      setSelectedImage(null);
    } else {
      setImageUploadError('');
      setSelectedImage(file);
    }
  };

  img.onerror = () => {
    URL.revokeObjectURL(objectUrl);
    setImageUploadError(`The selected file <em>${file.name}</em> cannot be uploaded. Only files with the following extensions are allowed: <em>png, gif, jpg, jpeg</em>.`);
    e.target.value = '';
    setSelectedImage(null);
  };

  img.src = objectUrl;
};
useEffect(() => {
  if (formData.field_mentor_photo) {
    fetch(formData.field_mentor_photo)
      .then(res => res.blob())
      .then(blob => {
        const sizeKB = (blob.size / 1024).toFixed(2);

        const img = new Image();
        img.onload = () => {
          setSavedImageInfo({
            size: sizeKB,
          
          });
        };
        img.src = URL.createObjectURL(blob);
      })
      .catch(() => {
        setSavedImageInfo({ size: null });
      });
  }
}, [formData.field_mentor_photo]);
 
    const [html, setHtml] = useState('');
  
    function onChange(e) {
        setHtml(e.target.value);
    }

const handleSubmit = async (e) => {
    e.preventDefault();
    setImageUploadError(''); // clear previous error
      // Sanitize biography field before submit
  const sanitizedFormData = {
    ...formData,
    field_mentor_biography: isEditorEmpty(formData.field_mentor_biography)
      ? ""
      : formData.field_mentor_biography,
  };
    const postData = new FormData();
      postData.append('file', selectedImage);
      postData.append('formData', JSON.stringify(sanitizedFormData));
      //postData.append('formData', JSON.stringify(formData));
        console.log("Submitting formData:", sanitizedFormData);
      const response = await fetch(app_url+'editprofile/putusermentoreditdetails', {
      method: 'POST',
      body: postData,
     
      });
      const data = await response.json();
      if(data.data.msg === "Success") {
        setSuccess(data.data.result);
       
        window.scrollTo(0, 0);
      }
};

  const handleCancel = () => {
    setFormData(initialForm);
    setHtml('<ul><li>SMWW Agency Director</li></ul>');
    setSelectedImage(null);
  };
    return(
       
                <div className="edit-mentor-container">
                    <div>
                      {success.length > 0 && (
                        <>
                        {success.map((item, index) => {
                          return <>
                          <br/><div className="set-message-done">
                          <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {item}
                          </div></>
          
                        })}  
                        </>
                      )}
                        <form onSubmit={handleSubmit}>
                            <div className="form-item">
                                <label htmlFor="edit-mentor-sort-order">
                                    Mentor Sort Order
                                </label>
                                <select
                                    id="edit-mentor-sort-order"
                                    name="field_mentor_sort_order"
                                    value={formData.field_mentor_sort_order}
                                    onChange={handleChange}
                                >
                                    <option value="">- None -</option>
                                    {Array.from({ length: 20}, (_, i) => {
                                        const sort = (i + 1).toString().padStart(1, '0');
                                        return <option key={sort} value={sort}>{sort}</option>;
                                    })}
                                </select>
                            </div>
                            <div className="form-item">
                                <label htmlFor="edit-mentor-title">Mentor Title (Shown on the mentor's bio page)</label>
                                <input className="edit-mentor-title-field" type="text" id="edit-mentor-title" onChange={handleChange} name="field_mentor_title" maxLength={100} value={formData.field_mentor_title}/>
                            </div>
                            <div className="form-item">
                                <label htmlFor="edit-mentor-bio">Mentor Biography (Shown in the mentor's box on course pages)</label>
                                <div className="form-textarea-wrapper">
                                    <div>
                                        {useEditor ? (
                                            <>
                                                <Editor 
                                                    containerProps={{ style: { resize: 'vertical' } }} 
                                                    value={formData.field_mentor_biography} 
                                                    onChange={onEditorChange}
                                                />
                                            </>
                                        ) : (
                                            <>
                                                <textarea 
                                                    className="edit-mentor-form-bio" 
                                                    id="edit-mentor-biography" 
                                                    name="field_mentor_biography"
                                                    onChange={(e) => setFormData((prev) => ({ ...prev, field_mentor_biography: e.target.value })) }
                                                    value={formData.field_mentor_biography} 
                                                    rows={5}
                                                >
                                                </textarea>
                                                <div className="grippie" style={{
                                                    background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
                                                }}>
                                                </div>
                                            </>
                                        )}
                                        <a onClick={toggleMentorBioEditor}>Switch to {useEditor ? "Plain Text Editor" : "Rich Text Editor"}</a>
                                    </div>
                                </div>
                            </div>
                          
                            <div className="form-item">
{imageUploadError && (
  <div 
    style={{ color: '#d9534f', 
    border: '1px solid #d9534f',
    backgroundColor: '#fef5f1', 
    padding: '10px 10px 10px 50px', 
    marginBottom: '10px',
    width: '90%', 
    borderRadius: '5px',
   background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat` }}
       dangerouslySetInnerHTML={{ __html: imageUploadError }}
    >
 
  </div>
)}

  <label htmlFor="edit-mentor-photo-upload">Mentor Photo</label>
  <div>
    {formData.field_mentor_photo ? (
      <>
      <div className="edit-mentor-image-container">
          <img
            alt="Uploaded"
            src={formData.field_mentor_photo}
           width="90" height="100"
          />
          
          <div className="image-info">
            <a
              href={formData.field_mentor_photo}
              target="_blank"
              rel="noopener noreferrer"
              className="image-name-link"
            >
              {formData.field_mentor_photo.replace("/basic/web/pictures/", "")}
            </a>
              {savedImageInfo.size && (
              <span className="image-size">
                {' '}({savedImageInfo.size} KB)
              </span>
            )}
          </div>
        </div>

        <input
          type="button"
          value="Remove"
          className="form-submit"
          onClick={() => setFormData((prev) => ({ ...prev, field_delete_photo:1,field_mentor_photo:'' }))}
        />
      </>
    ) : selectedImage ? (
      <>
        <div className="edit-mentor-image-container">
          <img
            alt="Uploaded" width="90" height="100" 
            src={URL.createObjectURL(selectedImage)}
           
          />
          <div className="image-info">
            <img src="/basic/web/images/image-x-generic.png" style={{width:"16px",height:"16px"}}/>
            <a
              href={URL.createObjectURL(selectedImage)}
              target="_blank"
              rel="noopener noreferrer"
              className="image-name-link"
            >
              {selectedImage.name}
            </a>
            <span className="image-size">
              {' '}({(selectedImage.size / 1024).toFixed(2)} KB)
            </span>
          </div>
        </div>

        <input
          type="button"
          value="Remove"
          className="form-submit"
          onClick={() => setSelectedImage(null)}
        />
      </>
    ) : (
      <>
        <input
          type="file"
          id="edit-mentor-photo-upload"
          name="edit_mentor_photo_upload"
          accept="image/*"
          onChange={handleFileChange}
        />
        <input
          type="button"
          value="Upload"
          className="form-submit"
          onClick={() =>
            document.getElementById('edit-mentor-photo-upload').click()
          }
        />
        <div className="description">
        Image size must be a minimum of 100×100 px or a maximum of 1000×1000 px <br />
        Files must be less than <b>128 MB</b>.<br />
        Allowed file types: <b>png gif jpg jpeg</b>.
        </div>
      </>
      
    )}
  </div>

 
</div>
<div style={{clear:"both"}}></div>
                            <div className="form-actions">
                                <input type="submit" value="Save" className=" form-submit" />
                                <input type="submit" value="Cancel account" className="edit-mentor-form-cancel" onSubmit={handleCancel}
                                    style={{ background: `#999 url("/basic/web/images/overlay.png") repeat-x` }} 
                                />
                            </div>
                    
                        </form>
                    </div>
                </div>
            
          
        
        
    );
}
export default EditMentor;